export const debounce = (func, time) => {
    let timeoutId = null;
    const delay = import.meta.env.MODE === 'test' ? 0 : time;
    const debounced = (...args) => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            timeoutId = null;
            func(...args);
        }, delay);
    };

    debounced.cancel = () => {
        if (!timeoutId) return;
        clearTimeout(timeoutId);
        timeoutId = null;
    };

    return debounced;
};
